import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const Charts = ({ data }) => {
  return <HighchartsReact highcharts={Highcharts} options={data} />
}

export default Charts
